import { ActionTypes } from 'constants/MogamboConstants';
import { dispatch } from '@src/dispatcher';
import * as Api from '@src/api';
import { GOOGLE_ANALYTICS, PERMISSION_LEVELS } from '@src/const';
import {
  userHasPermission,
  permissionErrorAlert,
  sendGoogleAnalyticsEvents,
} from './_utils';

export function copyPaste(payload, selectedOption, cb) {
  if (!userHasPermission(PERMISSION_LEVELS.MOGAMBO_ALL_EDIT)) {
    return permissionErrorAlert('copy paste bots');
  }

  const eventSource = `${payload.copy_component}_${selectedOption}`;

  let copyName = '';
  if (payload.copy_component === 'story') {
    copyName = payload.data.domain[0].story[0].from;
  } else if (payload.copy_component === 'domain') {
    copyName = payload.data.domain[0].from;
  }
  sendGoogleAnalyticsEvents(
    GOOGLE_ANALYTICS.CATEGORY.COPYPASTE,
    eventSource,
    copyName,
    GOOGLE_ANALYTICS.VALUE.SINGLE_CLICK
  );

  Api.copyPasteBotComponents(payload, cb);
}

export function copySubStory(meta, subStoryToCopy, callback) {
  const fromData = {
    type: 'substory',
    domainName: meta.domain.title,
    storyName: meta.story.title,
    subStoryName: subStoryToCopy.title,
    isSmartSkill: subStoryToCopy.smart_skill,
  };
  dispatch(ActionTypes.COPY_SUBSTORY, { fromData, callback });
}

export function resetSubStoryCopy(callback) {
  const fromData = {
    type: 'reset',
    domainName: '',
    storyName: '',
    subStoryName: '',
  };
  dispatch(ActionTypes.COPY_SUBSTORY_RESET, { fromData, callback });
}

export function copyNode(meta, nodeToCopy, callback) {
  const fromData = {
    type: 'node',
    domainName: meta.domain.title,
    storyName: meta.story.title,
    subStoryName: meta.subStory.title,
    nodeName: nodeToCopy.system_name,
  };
  dispatch(ActionTypes.COPY_NODE, { fromData, callback });
}

export function dragNode(fromSubStory, nodesToCopy, index) {
  const dragData = {
    type: 'node',
    subStory: fromSubStory,
    nodes: nodesToCopy,
    nodeIndex: index,
  };
  dispatch(ActionTypes.DRAG_NODE, { dragData });
}

export async function dropNode(meta, subStory, dropData, cb) {
  if (!userHasPermission(PERMISSION_LEVELS.MOGAMBO_ALL_EDIT)) {
    return permissionErrorAlert('move nodes');
  }

  const response = await Api.moveNodesAsync(dropData.nodes, subStory, meta.domain.title);
  if (response.success) {
    Api.getSubstoryGraph(meta.story.id, () => {
      if (cb) cb(false);
      dispatch(ActionTypes.FORCE_UPDATE_GRAPH, { REFRESH: true });
    });
  } else {
    cb(true);
  }
}

export function resetDragDrop() {
  dispatch(ActionTypes.DRAG_DROP_RESET, {});
}

export function pasteSubStory(meta, fromData, newSubStoryName, callback) {
  const payload = {
    copy_component: 'substory',
    copying_options: {
      copy_node_user_says: 1,
      copy_node_bot_says: 1,
      copy_node_connections: 1,
    },
    data: {
      domain: [
        {
          from: fromData.domainName,
          to: meta.domain.title,
          story: [
            {
              from: fromData.storyName,
              to: meta.story.title,
              substory: [
                {
                  from: fromData.subStoryName,
                  to: newSubStoryName,
                  smart_skill: fromData.isSmartSkill,
                },
              ],
            },
          ],
        },
      ],
    },
  };

  return Api.copyPasteAsync(payload).then(response => {
    dispatch(ActionTypes.COPY_PASTE_RESET);
    if (callback) callback(!response.success);

    const eventSource = `${payload.copy_component}_everything`;
    const copyName = fromData.subStoryName;
    sendGoogleAnalyticsEvents(
      GOOGLE_ANALYTICS.CATEGORY.COPYPASTE,
      eventSource,
      copyName,
      GOOGLE_ANALYTICS.VALUE.SINGLE_CLICK
    );

    Promise.resolve();
  });
}

export async function pasteNode(meta, fromData, subStoryName, callback) {
  const payload = {
    copy_component: 'nodes',
    copying_options: {
      copy_node_user_says: 1,
      copy_node_bot_says: 1,
      copy_node_connections: 1,
    },
    data: {
      domain: [
        {
          from: fromData.domainName,
          to: meta.domain.title,
          story: [
            {
              from: fromData.storyName,
              to: meta.story.title,
              substory: [
                {
                  from: fromData.subStoryName,
                  to: subStoryName,
                  nodes: [fromData.nodeName],
                },
              ],
            },
          ],
        },
      ],
    },
  };

  return Api.copyPasteAsync(payload).then(response => {
    dispatch(ActionTypes.COPY_PASTE_RESET);
    if (callback) callback(!response.success);

    const eventSource = `${payload.copy_component}_everything`;
    const copyName = fromData.nodeName;
    sendGoogleAnalyticsEvents(
      GOOGLE_ANALYTICS.CATEGORY.COPYPASTE,
      eventSource,
      copyName,
      GOOGLE_ANALYTICS.VALUE.SINGLE_CLICK
    );

    return Promise.resolve();
  });
}
